import {SOPutNotification} from '../../core/notification/so-put-notification';
import {NotificationCore} from './notification.core';
import {SOGetNotification} from '../../core/notification/so-get-notification';
import {FormField, SelectionOption} from 'lionheartland';
import {putNotificationFormFieldOptions} from './put-notification-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {MessageCore} from '../message/message.core';
import {SOGetMessage} from '../../core/message/so-get-message';

export class RAPutNotification extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putNotificationFormFieldOptions);

  RequestClass = SOPutNotification

  constructor(
    public entityCore: NotificationCore
  ) {
    super();
    if (putNotificationFormFieldOptions.message) {
      putNotificationFormFieldOptions.message.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('status'),
      this.getFormValueFromIdentifier(
        'message',
        SOGetMessage,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}